<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Sổ điểm" :link="[{ text: 'Số điểm', href: '/marks' }]" />
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <ExcelActions />
    </v-card>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <MarkFilter @onFilterChanged="refresh" />
    </v-card>

    <v-card v-show="semesters.length" class="mx-4 elevation-0">
      <!-- <v-row class="pa-4 pr-8 justify-end">
        <v-btn v-if="$vuetify.breakpoint.mdAndUp" class="mr-2" outlined color="success" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
      </v-row> -->

      <!-- <MarkDataTable :factors="factors" :semester="semester" :studentMarks="semester && semester.type !== 'year' ? marks : avgMarkYear" class="pa-4" /> -->
      <ClassMarkDataTable ref="table" />
    </v-card>
    <MarkBlankView class="mx-4" v-if="!semesters.length" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import MarkFilter from '@/modules/mark/MarkFilter'
import MarkBlankView from '@/modules/mark/MarkBlankView.vue'
import ClassMarkDataTable from '@/modules/mark/ClassMarkDataTable.vue'
import ExcelActions from '@/modules/mark/class-view/ExcelActions.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Breadcrumbs,
    MarkFilter,
    MarkBlankView,
    ClassMarkDataTable,
    ExcelActions
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    ...mapState('ClassMark', ['semesters'])
  },
  methods: {
    refresh(query) {
      this.$refs.table.refresh(query)
    },
    exportExcel() {
      // todo
    }
  },
  created() {}
}
</script>
